export default ({ request }) => ({

  resFabricRecodeListApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/list',
      method: 'post',
      data
    })
  },
  resFabricRecodeAddSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/addSave',
      method: 'post',
      data
    })
  },
  resFabricRecodeEditSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/editSave',
      method: 'post',
      data
    })
  },
  resFabricRecodeDetailApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/detail',
      method: 'post',
      data
    })
  },
  resFabricRecodeDelApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/del',
      method: 'post',
      data
    })
  },
  resFabricRecodeReleaseApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/recode/release',
      method: 'post',
      data
    })
  },

  resFabricScmPcAddSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/pc/add/save',
      method: 'post',
      data
    })
  },
  resFabricScmPcEditSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/pc/edit/save',
      method: 'post',
      data
    })
  },
  resFabricScmPcListContainFabricApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/listContainFabric',
      method: 'post',
      data
    })
  },
  resFabricScmPcDetailContainFabricApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/detailContainFabric',
      method: 'post',
      data
    })
  },
  resFabricScmPcDetailApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/pc/detail',
      method: 'post',
      data
    })
  },
  resFabricScmDelApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/del',
      method: 'post',
      data
    })
  },
  resFabricScmCardOcrApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/cardOcr',
      method: 'post',
      data
    })
  },
  resFabricScmOcrSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/ocrSave',
      method: 'post',
      data
    })
  },



  resFabricScmImageListApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/image/list',
      method: 'post',
      data
    })
  },
  resFabricScmImageDetailApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/image/detail',
      method: 'post',
      data
    })
  },
  resFabricScmImageUploadApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/image/upload',
      method: 'post',
      data
    })
  },
  resFabricScmImagSetDefaultApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/image/setDefault',
      method: 'post',
      data
    })
  },
  resFabricScmImageDelApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/scm/image/del',
      method: 'post',
      data
    })
  },



  resFabricInfoPcPushImgApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/pc/push/img',
      method: 'post',
      data,
      timeout: 60000,
    })
  },

  resFabricInfoDetailApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/detail',
      method: 'post',
      data
    })
  },
  resFabricInfoChooseListApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/choose/list',
      method: 'post',
      data
    })
  },
  resFabricInfoSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/save',
      method: 'post',
      data
    })
  },
  resFabricInfoDelApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/pc/del',
      method: 'post',
      data
    })
  },
  resFabricInfoUpdateImageApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/update/img',
      method: 'post',
      data
    })
  },

  resFabricInfoColorListApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/color/list',
      method: 'post',
      data
    })
  },
  resFabricInfoColorUploadApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/color/upload',
      method: 'post',
      data
    })
  },
  resFabricInfoColorDelApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/color/del',
      method: 'post',
      data
    })
  },
  resFabricInfoColorChooseSaveApi(data) {
    return request({
      url: '/digitalCenter/res/fabric/info/color/choose/save',
      method: 'post',
      data
    })
  },








})
